<template>
  <Card :bordered="false" dis-hover>
    <div slot="title">
      <slot name="title"></slot>
      <p class="title-item">{{ this.$t('common.this_day') }}</p>
    </div>
    <a href="#" slot="extra">
      <Button size="small" type="dashed" class="extra-btn" @click="goTo">
        {{ $t('common.more') }}
        <Icon type="ios-arrow-forward" />
      </Button>
      <slot name="extra"></slot>
    </a>
    <Spin size="large" v-if="isLoading" fix></Spin>
    <div style="display: flex">
      <div id="chart_sex" style="height: 260px"></div>
      <div id="chart_age" style="height: 260px"></div>
    </div>
  </Card>
</template>

<script>
import * as echarts from 'echarts';
import getI18nByKey from '@/common/js/getI18nByKey';
import api from '../../../api/home/index';
const DEFAULT = {
  sex_map: {
    1: getI18nByKey('common.male'),
    2: getI18nByKey('common.female'),
    0: getI18nByKey('common.unknown'),
  },
  age_map: {
    0: getI18nByKey('common.Teenagers'),
    1: getI18nByKey('common.Youth'),
    2: getI18nByKey('common.Middle_Age'),
    3: getI18nByKey('common.Middle_Old'),
    4: getI18nByKey('common.Elderly'),
  },
  sex_color: ['#208bee', '#e40b33', '#deecf9'],
  age_color: ['#4489e5', '#78a8eb', '#9ac0f3', '#c2dcf5', '#deecf9'],
};
export default {
  data() {
    return {
      isLoading: true,
      mySexChart: null,
      myAgeChart: null,
      sexMap: null,
      ageMap: null,
    };
  },
  mounted() {
    this.getAjaxData();
  },
  methods: {
    myEchartsResize() {
      this.mySexChart && this.mySexChart.resize();
      this.myAgeChart && this.myAgeChart.resize();
    },
    /**
     * @author lt
     */
    goTo() {
      this.$system.goRouter({
        router: {
          system: ccconstants.SYSTEM_NOS.Web_People_Counting,
          url: `/passenger-flow/accurate`,
        },
      });
    },
    /**
     * @description request ajax
     * @author lt
     */
    async getAjaxData() {
      const formattedDate = new Date().toISOString().split('T')[0];
      const p = {
        stime: `${formattedDate} 00:00:00`,
        etime: `${formattedDate} 23:59:59`,
        startHour: 0,
        endHour: 24,
        id: 'allShopsOfUser',
        isOnBusinessTime: 1,
      };
      const r = await this.launchGetAge(p);
      if (!r) return;
      const { genderDistribution, ageDistribution } = r;
      if (genderDistribution.length > 0 && ageDistribution.length > 0) {
        this.handleGetAge(r);
        this.initChats();
      }
    },
    /**
     * @author lt
     * @param {Object} p ajax params
     */
    async launchGetAge(p) {
      try {
        return await api.getAccurateAgeSex(p);
      } catch (e) {
        console.error(`[🤢🤢🤢🤢]-[getPersonalizationAgeGroupAndGenderDistribution]${e}`);
      } finally {
        this.isLoading = false;
      }
    },
    /**
     * @author lt
     * @param {Object} r ajax result
     */
    handleGetAge(r) {
      this.sexMap = r.genderDistribution.map(r => {
        return { name: DEFAULT.sex_map[r.gender], value: r.peopleNum, per: `${r.percentage}%` };
      });
      this.ageMap = r.ageDistribution.map((r, i) => {
        const { ageDivisionType } = r;
        return {
          ageType: r.ageDivisionType,
          value: r.peopleNum,
          per: `${r.percentage}%`,
          ageRange: `${r.ageFrom}-${r.ageTo}`,
          name: ageDivisionType === -1 ? r.name : DEFAULT.age_map[i],
        };
      });
    },
    /**
     * @author lt
     * @description init charts
     */
    initChats() {
      this.myAgeChart = echarts.init(document.getElementById('chart_age'));
      this.mySexChart = echarts.init(document.getElementById('chart_sex'));
      this.mySexChart.setOption(this.configOptions(this.sexMap, 'sex_color', 0, this.$t('common.Gender')));
      this.myAgeChart.setOption(this.configOptions(this.ageMap, 'age_color', 0, this.$t('common.Age')));
    },
    /**
     * @author lt
     * @description config e charts [legend series tooltip grid]
     * @param {Object} d origin data
     * @param {String} t color type
     * @param {Number} s show legend?
     * @param {String} e title
     */
    configOptions(d, t, s, e) {
      return {
        graphic: {
          type: 'text',
          left: 'center',
          bottom: 10,
          silent: true,
          style: {
            text: e,
            textAlign: 'center',
            fill: '#000',
            fontSize: 16,
          },
        },
        color: DEFAULT[t],
        tooltip: {
          show: true,
          trigger: 'item',
          position: 'right',
        },
        ...(s
          ? {
              legend: {
                // type: 'scroll',
                orient: 'horizontal',
                bottom: '0%',
                left: '10%',
                itemHeight: 12,
                itemWidth: 12,
                itemGap: 12,
                textStyle: {
                  rich: {
                    n: {
                      display: 'inline-block',
                      // width: 40,
                    },
                    v: {
                      display: 'inline-block',
                      // width: 20,
                    },
                  },
                },
                formatter: p => {
                  const item = d.find(item => p === item.name);
                  if (item) {
                    return `{n|${item.name}} {v|${item.value}}`.trim();
                  }
                  return '';
                },
              },
            }
          : ''),
        series: [
          {
            type: 'pie',
            radius: ['30%', '46%'],
            center: ['50%', '42%'],
            avoidLabelOverlap: true,
            label: {
              show: true,
              position: 'outside',
              formatter: p => `${p.data.per}`,
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 20,
                fontWeight: 'bold',
              },
            },
            labelLine: {
              show: true,
            },
            data: d,
          },
        ],
      };
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .ivu-card-head p {
    width: auto;
  }
}
#chart_sex,
#chart_age {
  width: 50%;
  height: 100%;
}
.title-item {
  padding: 0 5px;
  height: 18px;
  background: #f0f0f0;
  border-radius: 3px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 12px;
  color: #b2b2b2;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
  margin-left: 6px;
}
</style>
